import { adminUpdateClientResponse } from './adminUpdateClient';
import { clientDepartmentCreateResponse } from './createClientDepartment';
import { clientGroupSourceCreateResponse } from './clientGroupSourceCreate';
import { clientGroupSourceUpdateResponse } from './clientGroupSourceUpdate';
import { clientLocationCreateResponse } from './createClientLocation';
import { createClientFollowMappingResponse } from './createClientFollowMapping';
import { createCommentResponse } from './createComment';
import { createGroupModeratorResponse } from './createGroupModerator';
import { createLeaderboardResponse } from './createLeaderboard';
import { createReactionResponse } from './createReaction';
import { createUserSegmentResponse } from './createUserSegment';
import { deleteCommentResponse } from './deleteComment';
import { deleteGroupModeratorResponse } from './deleteGroupModerator';
import { deleteReactionResponse } from './deleteReaction';
import { deleteSocialConnectionResponse } from './deleteSocialConnection';
import { followResponse } from './follow';
import { markInboxAsReadResponse } from './markInboxAsRead';
import { processContentResponse } from './processContent';
import { clientDepartmentUpdateResponse } from './updateClientDepartment';
import { clientLocationUpdateResponse } from './updateClientLocation';
import { updateCommentResponse } from './updateComment';
import { updateContentApprovalsResponse } from './updateContentApprovals';
import { unfollowResponse } from './unfollow';

export {
  adminUpdateClientResponse,
  clientDepartmentCreateResponse,
  clientDepartmentUpdateResponse,
  clientGroupSourceCreateResponse,
  clientGroupSourceUpdateResponse,
  clientLocationCreateResponse,
  clientLocationUpdateResponse,
  createClientFollowMappingResponse,
  createCommentResponse,
  createGroupModeratorResponse,
  createLeaderboardResponse,
  createReactionResponse,
  createUserSegmentResponse,
  deleteCommentResponse,
  deleteGroupModeratorResponse,
  deleteReactionResponse,
  deleteSocialConnectionResponse,
  followResponse,
  markInboxAsReadResponse,
  processContentResponse,
  updateCommentResponse,
  updateContentApprovalsResponse,
  unfollowResponse,
};
